import { twMerge } from "tailwind-merge";
import { labelClass, labelSize, labelType } from "./constants";
import { LABEL_COLOR, LABEL_SIZE, LABEL_STYLE, LABEL_TYPE } from "./types";

interface Props {
  size: LABEL_SIZE;
  type: LABEL_TYPE;
  color: LABEL_COLOR;
  style: LABEL_STYLE;
  className?: string;
}

export const useLabelStyles = ({
  size,
  type,
  color,
  style,
  className,
}: Props) => {
  const base = "flex items-center";

  const computed = twMerge(
    labelSize[size],
    labelClass[style][color],
    labelType[type],
    base,
    className
  );

  return {
    className: computed,
  };
};
